/**
 * Remember: always add new reducers to the /reducers/index.js file!
 * Also, add your initialState to './initialstate'!
 */
import * as types from '../actions/actiontypes'; //just externalizes action name constants
import initialState from './initialstate';
import Utility from '../util/utils';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function FavoriteEngagementsReducer(
	//state = initialState.<%=names.camel%>,//TODO: uncomment this. Get from initialState.
	state = initialState.favoriteEngagements, //{Workspaces: {}},
	action
) {
	switch (action.type) {
		case types.LOAD_FAVORITES_ENGAGEMENTS:
			// Use the sortOrder from the action if provided, otherwise use the default sort order
			return Utility.formatAndSortEngagements(
				action.response,
				action.sortOrder
			);
		default:
			return state;
	}
}

// The formatAndSortEngagements function has been moved to utils.js
